<template>
    <div class="marketingTableContent">
        <div class="marketingTitle" @click="handleEdit('add')">添 加</div>
        <div class="marketing-table">
            <div class="el-table-list-content-all">
                <el-table :data="tableData">
                    <el-table-column type="index" width="50"></el-table-column>
                    <el-table-column :resizable="false" prop="name" label="运营活动名称" align="center" width="140px"></el-table-column>
                    <el-table-column :resizable="false" prop="remark" label="说明" min-width="200px" align="center"></el-table-column>
                    <el-table-column :resizable="false" prop="date" label="活动时间" align="center" width="220px"></el-table-column>
                    <el-table-column :resizable="false" prop="giveText" label="活动奖励" align="center" width="120px">
                        <template slot-scope="scope">
                            <el-tooltip :content="scope.row.giveText" placement="left" effect="dark">
                                <el-button class="keyButton">{{ scope.row.giveText }}</el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column :resizable="false" prop="statusText" label="是否启用" align="center" width="120px"></el-table-column>
                    <el-table-column label="操作" width="330">
                        <template slot-scope="scope" :resizable="false" align="center">
                            <el-button size="mini" type="primary" @click="handleEdit('edit',scope.row)">编辑</el-button>
                            <el-button size="mini" type="warning" v-if="scope.row.status == 1" @click="scopBtn(0, scope.row)">禁用</el-button>
                            <el-button size="mini" type="success" v-if="scope.row.status == 0" @click="scopBtn(1, scope.row)">启用</el-button>
                            <el-button size="mini" type="info" @click="scopBtn(2, scope.row)">明细</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="bottom-paginations">
                    <el-pagination background @current-change="handleCurrentChanges" :current-page.sync="currentPage" :page-size="pageLimit" layout="prev, pager, next, jumper" :total="totalSize"></el-pagination>
                </div>
            </div>
        </div>
        <el-dialog class="dialogInfo" title="提示" :visible.sync="dialogVisible" width="1300px" :before-close="handleClose">
            <div class="searchBox">
                <el-input v-model="mobile" placeholder="输入手机号查询"></el-input>
                <el-button icon="el-icon-search" type="primary" clearable @click="searchBtn">搜 索</el-button>
            </div>
            <el-table :data="tableInfoList">
                <el-table-column :resizable="false" prop="userName" label="邀请人/名字" align="center"></el-table-column>
                <el-table-column :resizable="false" prop="mobile" label="手机号" min-width="100px" align="center"></el-table-column>
                <el-table-column :resizable="false" prop="type" label="获得奖励类型" align="center"></el-table-column>
                <el-table-column :resizable="false" prop="giveInfo.couponAmount" label="获得奖励" align="center"></el-table-column>
                <el-table-column :resizable="false" prop="giveInfo.couponName" label="规则" align="center"></el-table-column>
            </el-table>
            <div class="dialogPaginations">
                <el-pagination background @current-change="handleCurrentChangeInfo" :current-page.sync="infoCurrentPage" :page-size="infoPageLimit" layout="prev, pager, next, jumper" :total="infoTotalSize"></el-pagination>
            </div>
        </el-dialog>
        <el-dialog class="dialogInfo" title="提示" :visible.sync="inviteDialogVisible" width="1300px" :before-close="handleClose">
            <div class="searchBox">
                <el-input v-model="mobile" placeholder="输入手机号查询"></el-input>
                <el-button icon="el-icon-search" type="primary" clearable @click="searchBtn">搜 索</el-button>
            </div>
            <el-table :data="inviteInfoList">
                <el-table-column :resizable="false" prop="inviteUserName" label="用户名" width="160px" align="center"></el-table-column>
                <el-table-column :resizable="false" prop="inviteUserPhone" label="手机号" align="center" width="160px"></el-table-column>
                <el-table-column :resizable="false" prop="inviteNum" label="邀请人数/名次" align="center" width="150px"></el-table-column>
                <el-table-column :resizable="false" prop="useScopeType" label="获得奖励类型" align="center" width="120px"></el-table-column>
                <el-table-column :resizable="false" prop="amount" label="消费总额" align="center"></el-table-column>
                <el-table-column :resizable="false" prop="couponName" label="规则" align="center"></el-table-column>
            </el-table>
            <div class="dialogPaginations">
                <el-pagination background @current-change="handleCurrentChangeInfo" :current-page.sync="infoCurrentPage" :page-size="infoPageLimit" layout="prev, pager, next, jumper" :total="infoTotalSize"></el-pagination>
            </div>
        </el-dialog>
        <el-dialog class="dialogInfo" title="提示" :visible.sync="rankingDialogVisible" width="1300px" :before-close="handleClose">
            <div class="searchBox">
                <el-input v-model="hourMobile" placeholder="输入手机号查询"></el-input>
                <el-button icon="el-icon-search" type="primary" clearable @click="searchBtn">搜 索</el-button>
            </div>
            <el-table :data="rankingList">
                <el-table-column :resizable="false" prop="userName" label="用户名" min-width="100px" align="center"></el-table-column>
                <el-table-column :resizable="false" prop="mobile" label="手机号" align="center"></el-table-column>
                <el-table-column :resizable="false" prop="timeRank" label="排名/名次" align="center"></el-table-column>
                <el-table-column :resizable="false" prop="couponName" label="规则" align="center"></el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog class="dialogInfo" :title="titleText" :visible.sync="dialogVisibleShow" width="1300px" :before-close="handleClose">
            <MarketingInfo ref="getComInfo" @subBtn="subBtn" />
        </el-dialog>
    </div>
</template>

<script>
import requstsMethod from "common/const";
import { response } from "network/response";
import MarketingInfo from "./common/marketingInfo.vue"
export default {
    data () {
        return {
            tableData: [],
            tableInfoList: [],
            currentPage: 1,
            pageLimit: 10,
            totalSize: 0,
            infoTotalSize: 0,
            infoCurrentPage: 1,
            infoPageLimit: 10,
            mobile: '',
            hourMobile: '',
            taskId: '',
            dialogVisible: false,
            dialogVisibleShow: false,
            inviteDialogVisible: false,
            rankingDialogVisible: false,
            titleText: '',
            rowInfo: {},
            inviteInfoList: [],
            rankingList: [],
            billiardsId: JSON.parse(localStorage.billiardsInfo).billiardsId,
        }
    },
    components: { MarketingInfo },
    created () {
        this.getInit()
    },
    methods: {
        handleClose () {
            this.dialogVisible = false
            this.dialogVisibleShow = false
            this.inviteDialogVisible = false
            this.rankingDialogVisible = false
            this.infoTotalSize = 0
        },
        handleEdit (val, item) {
            switch (val) {
                case 'add':
                    this.titleText = '添加'
                    break;
                default:
                    this.titleText = '编辑'
            }
            if (val != 'add') {
                if (item.statusText == '已启用') {
                    this.$message({ message: `启用状态时不可编辑`, type: 'error' });
                } else {
                    this.dialogVisibleShow = true
                    this.$nextTick(() => {
                        this.$refs.getComInfo.getData(val, item)
                    })
                }
            } else {
                this.dialogVisibleShow = true
                this.$nextTick(() => {
                    this.$refs.getComInfo.getData(val, item)
                })
            }
        },
        async scopBtn (val, item) {
            this.rowInfo = item
            switch (val) {
                case 2:
                    this.infoCurrentPage = 1
                    switch (item.templateType) {
                        case 'recharge_give_coupon':
                            this.dialogVisible = true
                            this.tableInfo(item)
                            break;
                        case 'invite_new_user':
                            this.inviteDialogVisible = true
                            this.inviteTableInfo(item)
                            break;
                        case 'rank_give_award':
                            this.rankingDialogVisible = true
                            this.rankingInfo(item)
                            break;
                    }
                    break;
                default:
                    this.operateBtn(val, item)
                    break
            }
        },
        // 操作
        async operateBtn (val, item) {
            const data = await response(requstsMethod.fun_service_authorized_activity_task_update_status, {
                id: item.id,
                status: val
            })
            if (data == '成功') {
                let text = ''
                val == 0 ? text = '禁用' : text = '启用'
                this.$message({ message: `${text}成功`, type: 'success' });
                this.getInit()
            }
        },
        // 优惠券详情
        async tableInfo (item) {
            const params = {
                pageNo: this.infoCurrentPage,
                pageSize: this.infoPageLimit,
                taskId: item.id,
                mobile: this.mobile
            }
            const data = await response(requstsMethod.fun_service_authorized_activity_task_log_list, params)
            data.list.map(item => {
                item.type = item.giveInfo.couponUseScopeType == 1 ? item.type = '台费券' : item.type = '水机券'
            })
            this.tableInfoList = data.list
            this.infoTotalSize = data.total
        },
        // 邀请新用户详情
        async inviteTableInfo (item) {
            const params = {
                pageNo: this.infoCurrentPage,
                pageSize: this.infoPageLimit,
                taskId: item.id,
                mobile: this.mobile
            }
            const data = await response(requstsMethod.fun_Get_authorized_activity_task_statistics, params)
            data.list.map(item => {
                if (item.marketingCouponDto) {
                    item.marketingCouponDto.useScopeType == 1 ? item.useScopeType = '台费券' : item.useScopeType = '水机券'
                    item.amount = item.marketingCouponDto.amount
                    item.marketingCouponDto.couponName ? item.couponName = item.marketingCouponDto.couponName : item.couponName = '-'
                }
            })
            this.inviteInfoList = data.list
            this.infoTotalSize = data.total
        },
        // 排行榜详情
        async rankingInfo (item) {
            const params = {
                taskId: item.id,
                mobile: this.hourMobile,
                billiardsId: this.billiardsId
            }
            const data = await response(requstsMethod.fun_Get_authorized_coupons_rank_query, params)
            data.rankAwards.map(item => {
                item.timeRank = item.timeRankAwardGiveCouponInfo.timeRank
                item.timeRankAwardGiveCouponInfo.couponUseScopeType == 1 ? item.couponName = '台费券 ' + item.timeRankAwardGiveCouponInfo.couponName : item.couponName = '水机券 ' + item.timeRankAwardGiveCouponInfo.couponName
                item.couponNum = item.timeRankAwardGiveCouponInfo.couponNum
            })
            this.rankingList = data.rankAwards
            this.infoTotalSize = data.total
        },
        // 列表分页
        handleCurrentChanges (val) {
            this.currentPage = val
            this.getInit()
        },
        // 明细分页
        handleCurrentChangeInfo (val) {
            this.infoCurrentPage = val
            switch (this.rowInfo.templateType) {
                case 'recharge_give_coupon':
                    this.tableInfo(this.rowInfo)
                    break;
                case 'invite_new_user':
                    this.inviteTableInfo(this.rowInfo)
                    break;
                case 'rank_give_award':
                    this.rankingInfo(this.rowInfo)
                    break;
            }
        },
        // 初始化数据列表
        async getInit () {
            const params = {
                pageNo: this.currentPage,
                pageSize: this.pageLimit
            }
            const data = await response(requstsMethod.fun_service_authorized_activity_task_all_list, params)
            data.list.map(item => {
                item.date = item.startTime + ' - ' + item.endTime
                item.status == 1 ? item.statusText = '已启用' : item.statusText = '已禁止'
            })
            this.tableData = data.list
            this.totalSize = data.total
        },
        subBtn () {
            this.handleClose()
            this.getInit()
        },
        // 搜索
        searchBtn () {
            this.infoCurrentPage = 1
            switch (this.rowInfo.templateType) {
                case 'recharge_give_coupon':
                    this.tableInfo(this.rowInfo)
                    break;
                case 'invite_new_user':
                    this.inviteTableInfo(this.rowInfo)
                    break;
                case 'rank_give_award':
                    this.rankingInfo(this.rowInfo)
                    break;
            }
        }
    }
}
</script>

<style lang="scss">
.marketingTableContent {
    padding: 10px;
    background-color: #3d3d3d;

    .marketingTitle {
        width: 140px;
        height: 40px;
        line-height: 40px;
        margin: 10px 0 10px 10px;
        color: #fff;
        background-color: #409eff;
        font-size: 20px;
        font-weight: 500;
        text-align: center;
        word-spacing: 20px;
        border-radius: 4px;
        cursor: pointer;
    }
    .marketing-table {
        width: 100%;
        background-color: #3e3e3e;

        .el-table-list-content-all {
            margin: 10px 10px 0 10px;

            .el-table {
                border: 1px solid #566979;
                background: #3e3e3e;
                min-height: 480px;

                .el-table__header-wrapper {
                    .el-table__header {
                        thead {
                            tr {
                                th {
                                    background: #3e3e3e;
                                    color: #fff;
                                    border-bottom: 1px solid #566979;
                                    border-right: 1px solid #566979;
                                    padding: 0 !important;
                                    height: 45px;
                                    font-size: 16px;
                                    font-weight: 600;

                                    .cell {
                                        text-align: center;
                                        line-height: 20px;
                                    }
                                }
                            }
                        }
                    }
                }

                .el-table__body-wrapper {
                    // min-height: 450px;

                    .el-table__body {
                        tbody {
                            .el-table__row {
                                height: 45px;

                                td {
                                    background: #3e3e3e;
                                    color: #fff;
                                    border-bottom: 1px solid #566979;
                                    border-right: 1px solid #566979;
                                    padding: 0 !important;
                                    height: 30px;
                                    font-size: 14px;

                                    .cell {
                                        display: flex;
                                        justify-content: space-evenly;

                                        .el-button {
                                            font-size: 14px;
                                            width: 100px;
                                        }
                                        .el-tooltip {
                                            background-color: transparent;
                                            color: #fff;
                                            border: none;
                                            overflow: hidden;
                                            text-overflow: ellipsis;
                                        }
                                    }
                                }
                            }

                            .el-table__row:hover {
                                td {
                                    background: #566979;
                                }
                            }
                        }
                    }
                }
            }

            .el-table::before {
                background: #3e3e3e !important;
            }
        }

        .bottom-paginations {
            display: flex;
            justify-content: flex-end;
            margin: 10px 0;
            .el-pagination {
                .el-pager {
                    .el-icon {
                        background-color: #3e3e3e;
                        color: #fff;
                        box-shadow: 0px 0px 5px #000;
                    }

                    li:hover {
                        color: #fff !important;
                    }

                    .el-icon-d-arrow-left:hover {
                        color: #fff;
                    }

                    .number {
                        background: #3e3e3e;
                        box-shadow: 0px 0px 5px #000;
                        color: #fff;
                    }

                    .active {
                        background: #4d4d4d;
                    }
                }

                .el-pagination__jump {
                    color: #fff;
                    font-weight: 800;

                    .el-input {
                        .el-input__inner {
                            border: none;
                            background: #3e3e3e;
                            border-radius: 2px;
                            box-shadow: 0px 0px 5px #000;
                            color: #fff;
                        }
                    }
                }

                .btn-prev {
                    height: 30px;
                    background: #3e3e3e;
                    box-shadow: 0px 0px 5px #000;
                    color: #fff;
                }

                .btn-next {
                    height: 30px;
                    background: #3e3e3e;
                    box-shadow: 0px 0px 5px #000;
                    color: #fff;
                }
            }

            .enter-button {
                float: right;
                width: 40px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                box-shadow: 0px 0px 5px #000;
                font-size: 14px;
            }
        }
    }
    .dialogInfo {
        border-radius: 6px;

        .el-dialog__body {
            background-color: #3e3e3e;
            padding: 10px 20px 20px 20px;
            .searchBox {
                display: flex;
                align-items: center;
                margin: 10px 0;
                .el-input {
                    width: 360px;
                    margin-right: 20px;
                    .el-input__inner {
                        background-color: #3d3d3d !important;
                        border: none;
                        color: #fff;
                        box-shadow: 0 0 5px #000 inset;
                    }
                }
                .el-button {
                }
            }
            .el-table {
                border: 1px solid #566979;
                background: #3e3e3e;
                min-height: 300px;

                .el-table__header-wrapper {
                    .el-table__header {
                        thead {
                            tr {
                                th {
                                    background: #3e3e3e;
                                    color: #fff;
                                    border-bottom: 1px solid #566979;
                                    border-right: 1px solid #566979;
                                    padding: 0 !important;
                                    height: 45px;
                                    font-size: 16px;
                                    font-weight: 600;

                                    .cell {
                                        text-align: center;
                                        line-height: 20px;
                                    }
                                }
                            }
                        }
                    }
                }

                .el-table__body-wrapper {
                    min-height: 400px;

                    .el-table__body {
                        tbody {
                            .el-table__row {
                                height: 45px;

                                td {
                                    background: #3e3e3e;
                                    color: #fff;
                                    border-bottom: 1px solid #566979;
                                    border-right: 1px solid #566979;
                                    padding: 0 !important;
                                    height: 30px;
                                    font-size: 14px;

                                    .cell {
                                        display: flex;
                                        justify-content: space-evenly;
                                    }
                                }
                            }

                            .el-table__row:hover {
                                td {
                                    background: #566979;
                                }
                            }
                        }
                    }
                }
            }
            .dialogPaginations {
                display: flex;
                justify-content: flex-end;
                margin: 10px 0;
                .el-pagination {
                    .el-pager {
                        .el-icon {
                            background-color: #3e3e3e;
                            color: #fff;
                            box-shadow: 0px 0px 5px #000;
                        }

                        li:hover {
                            color: #fff !important;
                        }

                        .el-icon-d-arrow-left:hover {
                            color: #fff;
                        }

                        .number {
                            background: #3e3e3e;
                            box-shadow: 0px 0px 5px #000;
                            color: #fff;
                        }

                        .active {
                            background: #4d4d4d;
                        }
                    }

                    .el-pagination__jump {
                        color: #fff;
                        font-weight: 800;

                        .el-input {
                            .el-input__inner {
                                border: none;
                                background: #3e3e3e;
                                border-radius: 2px;
                                box-shadow: 0px 0px 5px #000;
                                color: #fff;
                            }
                        }
                    }

                    .btn-prev {
                        height: 30px;
                        background: #3e3e3e;
                        box-shadow: 0px 0px 5px #000;
                        color: #fff;
                    }

                    .btn-next {
                        height: 30px;
                        background: #3e3e3e;
                        box-shadow: 0px 0px 5px #000;
                        color: #fff;
                    }
                }

                .enter-button {
                    float: right;
                    width: 40px;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                    box-shadow: 0px 0px 5px #000;
                    font-size: 14px;
                }
            }
        }

        .el-dialog__header {
            text-align: left;
            background-color: #313131;

            .el-dialog__title {
                color: #fff;
                font-size: 22px;
            }

            .el-dialog__headerbtn {
                .el-dialog__close {
                    font-size: 22px;
                    font-weight: 800;
                    color: #fff;
                }
            }
        }
    }
}
</style>